export default "__VITE_ASSET__a47d2ca3__"